import React, { FC, useState, ReactElement, } from "react";

import { Collapsible, } from "components/FormControls";
import { getHash, classNames, } from "components/Utils";

type Props = {
    label: string;
    isCollapsed?: boolean;
    children?: React.ReactNode;
    icon?: JSX.Element;
};

export const Module: FC<Props> = (props: Props): ReactElement => {
    const { label, isCollapsed, children, icon, } = props;

    const hash = getHash(label);
    // !!getStorageItemValue(hash) operation needs double negation to prevent a typescript error
    const c = getStorageItemValue(hash) === null ? !!isCollapsed : !!getStorageItemValue(hash);
    const [moduleHash] = useState(hash);
    const [collapsed, setCollapsed] = useState(c);

    const handleToggle = (c: boolean) => {
        if (moduleHash === 0) {
            return;
        }

        const itemName = getStorageItemName(moduleHash);
        localStorage.setItem(itemName, c.toString());
        setCollapsed(c);
    };

    const css = classNames([]);

    return (
        <Collapsible
            label={label}
            isCollapsed={collapsed}
            className={css}
            onToggle={handleToggle}
            svg={icon}
        >
            {children}
        </Collapsible>
    );
};

const getStorageItemName = (hash: number): string => {
    return `module_${hash}`;
};

const getStorageItemValue = (hash: number): boolean | null => {
    if (hash === 0) {
        return null;
    }

    const itemName = getStorageItemName(hash);
    const value = localStorage.getItem(itemName);

    return value === null ? null : value === "true";
}
